import HeaderCompact from '../HeaderCompact'
import Search from './Search'
import classNames from 'classnames'
import commonStyles from '../shared/styles.module.css'
import styles from './Header.module.css'
import { DefaultImage, DefaultLink, LinkItem } from '../shared'
import { useCallback, useState } from 'react'
import type { HeaderProps } from './types'

function Header({
  Link = DefaultLink,
  Image = DefaultImage,
  children,
  text: { links, searchLabel, searchPlaceholder, searchUrl, ...text },
}: HeaderProps) {
  const [searchOpen, setSearchOpen] = useState(false)
  const openSearch = useCallback(() => setSearchOpen(true), [])
  const closeSearch = useCallback(() => setSearchOpen(false), [])
  return (
    <HeaderCompact
      Link={Link}
      Image={Image}
      text={text}
      hideClaim={searchOpen}
      className={classNames({ [styles.searchOpen!]: searchOpen, [styles.searchClosed!]: !searchOpen })}
    >
      <ul className={styles.links}>
        {links.map((linkProps, index) => (
          <li className={styles.linkItem} key={index}>
            <LinkItem
              Link={Link}
              data-axe-expect="color-contrast"
              className={classNames(commonStyles.navigationLink, commonStyles.headerLink)}
              {...linkProps}
            />
          </li>
        ))}
      </ul>
      {children}
      <Search
        open={searchOpen}
        text={{ placeholder: searchPlaceholder, label: searchLabel, url: searchUrl }}
        onShowSearch={openSearch}
        onHideSearch={closeSearch}
        className={styles.search}
      />
    </HeaderCompact>
  )
}

export default Header
